import styled from 'styled-components'


export const SC_GoToAllNews = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  margin-bottom: 16px;
  cursor: pointer;

  span {
    cursor: pointer;
  }
`
